import { useQuery } from '@tanstack/react-query'
import { getRecipe } from './recipes.service'

export function useRecipe(id: string) {
  return useQuery({
    queryKey: ['recipes', 'detail', id],
    queryFn: () => getRecipe(id),
  })
}
